export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_03.abf8680b.jpg";